"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CostItemTableTree = _interopRequireDefault(require("../CostItemTableTree"));
var _default = exports.default = {
  name: 'FormulaEditorSelectCostItemModal',
  // 公式编辑-选择科目
  components: {
    CostItemTableTree: _CostItemTableTree.default
  },
  props: {
    ..._CostItemTableTree.default.props,
    selectable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      selectedItemList: []
    };
  },
  methods: {
    open() {
      this.selectedItemList = [];
      this.visible = true;
    },
    handleChange({
      selectedItemList
    }) {
      this.selectedItemList = selectedItemList.map(item => {
        return {
          itemId: item._rawValue,
          itemName: item._title
        };
      });
    },
    handleOk() {
      if (this.selectedItemList.length === 0) {
        this.$message.warning('请选择科目');
        return;
      }
      this.$emit('ok', this.selectedItemList);
      this.visible = false;
    }
  }
};